import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Validator } from '@vista-digital/validator';
import { observer } from 'mobx-react';
export const headingLevels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const headingLevelValidator = Validator.oneOf(headingLevels);
export const Heading = observer(props => {
    const { level: Level, children } = props, other = __rest(props, ["level", "children"]);
    return _jsx(Level, Object.assign({}, other, { children: children }));
});
Heading.displayName = 'Heading';
//# sourceMappingURL=heading.js.map